(function () {
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: cur }); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  /* Mobile menu */
  var mm = $('[data-mobile-menu]');
  $$('[data-menu-toggle]').forEach(function (b) { b.addEventListener('click', function () { if (mm) mm.classList.add('is-open'); }); });
  if (mm) {
    $$('[data-menu-close]', mm).forEach(function (b) { b.addEventListener('click', function () { mm.classList.remove('is-open'); }); });
  }

  /* Search */
  var sp = $('[data-search-panel]');
  $$('[data-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!sp) return;
      sp.classList.toggle('is-open');
      var i = $('input[type=search]', sp);
      if (i && sp.classList.contains('is-open')) i.focus();
    });
  });
  if (sp) { $$('[data-search-close]', sp).forEach(function (b) { b.addEventListener('click', function () { sp.classList.remove('is-open'); }); }); }

  /* Cart drawer */
  var drawer = $('[data-cart-drawer]');
  function openCart() { if (drawer) { drawer.classList.add('is-open'); renderCart(); } }
  function closeCart() { if (drawer) drawer.classList.remove('is-open'); }
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });

  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.style.display = n > 0 ? 'flex' : 'none'; });
  }

  function renderCart() {
    var body = $('[data-cart-body]');
    var foot = $('[data-cart-foot]');
    if (!body) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateCount(cart.item_count);
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><p>Il tuo carrello \u00e8 vuoto.</p><a class="btn" href="/collections/all">Ritorna al negozio</a></div>';
        if (foot) foot.style.display = 'none';
        return;
      }
      if (foot) foot.style.display = 'block';
      body.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[^.\/]+)(\?|$)/, '_160x$1$2') : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<p class="cart-line__variant">' + it.variant_title + '</p>' : '';
        return '<div class="cart-line">' +
          '<img src="' + img + '" alt="">' +
          '<div><p class="cart-line__vendor">' + (it.vendor || '') + '</p>' +
          '<p class="cart-line__title">' + it.product_title + '</p>' + variant +
          '<div class="cart-line__bottom"><div class="qty">' +
          '<button data-change="' + it.key + '" data-qty="' + (it.quantity - 1) + '">-</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button data-change="' + it.key + '" data-qty="' + (it.quantity + 1) + '">+</button>' +
          '</div><span class="cart-line__price">' + money(it.final_line_price) + '</span></div></div>' +
          '<button class="cart-line__remove" data-change="' + it.key + '" data-qty="0">&times;</button>' +
          '</div>';
      }).join('');
      var sub = $('[data-cart-subtotal]');
      if (sub) sub.textContent = money(cart.total_price);
      $$('[data-change]', body).forEach(function (b) {
        b.addEventListener('click', function () {
          changeLine(b.getAttribute('data-change'), parseInt(b.getAttribute('data-qty'), 10));
        });
      });
    });
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { renderCart(); });
  }

  function addToCart(id, quantity, onDone) {
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] })
    }).then(function (r) { return r.json(); }).then(function () {
      if (onDone) onDone();
      openCart();
    }).catch(function () { if (onDone) onDone(); });
  }

  /* Quick add buttons */
  $$('[data-quick-add]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var id = b.getAttribute('data-variant-id');
      if (!id || b.disabled) return;
      var original = b.textContent;
      b.textContent = 'Aggiungo...';
      addToCart(id, 1, function () {
        b.textContent = 'Aggiunto \u2713';
        b.classList.add('is-added');
        setTimeout(function () { b.textContent = original; b.classList.remove('is-added'); }, 1600);
      });
    });
  });

  /* Product form */
  var pform = $('[data-product-form]');
  if (pform) {
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = pform.querySelector('[name=id]').value;
      var qEl = pform.querySelector('[name=quantity]');
      addToCart(id, qEl ? qEl.value : 1);
    });
  }

  /* Quantity steppers */
  $$('[data-qstep]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = $('#' + b.getAttribute('data-target'));
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v += parseInt(b.getAttribute('data-qstep'), 10);
      if (v < 1) v = 1;
      input.value = v;
    });
  });

  /* Initial cart count */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); }).catch(function () {});

  /* Accordion */
  $$('[data-accordion-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-accordion-item]');
      if (item) item.classList.toggle('is-open');
    });
  });

  /* Size guide modal */
  function openModal(sel) { var m = $(sel); if (m) m.classList.add('is-open'); }
  function closeModal(el) { var m = el.closest('.modal'); if (m) m.classList.remove('is-open'); }
  $$('[data-size-guide-open]').forEach(function (b) { b.addEventListener('click', function () { openModal('[data-size-guide]'); }); });
  $$('[data-modal-close]').forEach(function (b) { b.addEventListener('click', function () { closeModal(b); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { $$('.modal.is-open').forEach(function (m) { m.classList.remove('is-open'); }); } });

  /* Size guide tabs */
  $$('[data-sg-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var group = tab.closest('[data-sg-tabs]');
      var target = tab.getAttribute('data-sg-tab');
      $$('[data-sg-tab]', group).forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      $$('[data-sg-panel]', group.parentNode).forEach(function (p) {
        p.style.display = p.getAttribute('data-sg-panel') === target ? 'block' : 'none';
      });
    });
  });

  /* 3D tilt */
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) {
    $$('[data-tilt]').forEach(function (el) {
      var strength = parseFloat(el.getAttribute('data-tilt')) || 9;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(1200px) rotateY(' + (px * strength) + 'deg) rotateX(' + (-py * strength) + 'deg) scale(1.02)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = 'perspective(1200px) rotateY(0deg) rotateX(0deg) scale(1)';
      });
    });

    /* Parallax spotlight layers */
    $$('[data-parallax]').forEach(function (section) {
      section.addEventListener('mousemove', function (e) {
        var r = section.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        $$('[data-parallax-layer]', section).forEach(function (layer) {
          var depth = parseFloat(layer.getAttribute('data-parallax-layer')) || 20;
          layer.style.transform = 'translate(' + (px * depth) + 'px,' + (py * depth) + 'px) scale(1.08)';
        });
      });
      section.addEventListener('mouseleave', function () {
        $$('[data-parallax-layer]', section).forEach(function (layer) { layer.style.transform = 'translate(0,0) scale(1.08)'; });
      });
    });
  }

  /* Reviews carousel */
  $$('[data-carousel]').forEach(function (c) {
    var track = $('[data-carousel-track]', c);
    var prev = $('[data-carousel-prev]', c);
    var next = $('[data-carousel-next]', c);
    if (!track) return;
    function step() {
      var slide = track.querySelector('.carousel__slide');
      return slide ? slide.getBoundingClientRect().width + 20 : 320;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* Expose for inline product variant script */
  window.OutletTheme = { addToCart: addToCart };
})();
